import React, { useEffect, useState } from 'react';
import { Room } from '@mui/icons-material';
import { FACE_TO_FACE, MEET } from 'Constants/General';
import { ImageIconContainer, Icon, addressText, gpsIcon } from '../style';

const useSessionComponent = ({ sessionType, address, meetUrl }) => {
  const [sessionComponent, setSessionComponent] = useState();

  useEffect(() => {
    if (sessionType === MEET) {
      setSessionComponent(
        <>
          <ImageIconContainer>
            <img src="/googleMeetIcon.png" style={Icon} />
          </ImageIconContainer>
          <div style={addressText}>{meetUrl.length > 35 ? meetUrl.slice(0, 31).concat('...') : meetUrl}</div>
        </>
      );
    }
    if (sessionType === FACE_TO_FACE) {
      setSessionComponent(
        <>
          <Room style={gpsIcon} />
          <div style={addressText}>{address.split('-')[0]}</div>
        </>
      );
    }
  }, [sessionType]);

  return {
    sessionComponent,
  };
};

export default useSessionComponent;
